import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CREATE_ASSET_REFURBISHED_SUCCESS,
  FETCH_ASSET_REFURBISHED_SUCCESS,
  GET_ASSET_REFURBISHED_SUCCESS,
  SAVE_ASSET_REFURBISHED_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {fetchError, fetchStart, fetchSuccess} from "./Common";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_ASSET_REFURBISHED_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_ASSET_REFURBISHED_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_ASSET_REFURBISHED_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_ASSET_REFURBISHED_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {assetRefurbishedTransaction} = store.getState();
      const {query} = assetRefurbishedTransaction;
      const response = await axios.get(`/asset-refurbish-transaction?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {assetRefurbishedTransaction} = store.getState();
      const {query} = assetRefurbishedTransaction;
      const response = await axios.get(`/asset-refurbish-transaction/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const createResource = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      let formData = new FormData();
      const documentData = [];
      payload.documents.map((item, index) => {
        formData.append('files', item.file);
        let data = {...item};
        delete data.file;
        documentData.push(data)
      });

      formData.append('documentData', JSON.stringify(documentData));

      Object.keys(payload).forEach(key => {
        if (key === 'documents') {
          return
        }

        if (key === 'readings') {
          formData.append(key, JSON.stringify(payload[key]));
          return;
        }

        formData.append(key, payload[key]);
      });
      const response = await axios.post(`/asset-refurbish-transaction`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({data: response.data}));
      history.push('/asset-refurbish-transaction');
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      let formData = new FormData();

      const documentData = [];
      const documentIds = [];
      payload.documents.map((item, index) => {
        if (!item.file.path) {
          formData.append('files', item.file);
          let data = {...item};
          delete data.file;
          documentData.push(data)
        } else {
          documentIds.push(item._id);
        }
      });

      formData.append('documentData', JSON.stringify(documentData));
      formData.append('documentIds', JSON.stringify(documentIds));

      Object.keys(payload).forEach(key => {
        if (key === 'documents') {
          return
        }

        if (key === 'readings') {
          formData.append(key, JSON.stringify(payload[key]));
          return;
        }

        formData.append(key, payload[key]);
      });
      await axios.put(`/asset-refurbish-transaction/${id}`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      dispatch(fetchSuccess());
      history.push('/asset-refurbish-transaction');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/asset-refurbish-transaction/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/asset-refurbish-transaction/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
